import React from 'react';
import './Sub-services.css';
import antenas from './assets/antenas.png';

const Antirrobo = () => {
  return (
    <div className="containerSer">
      <h2>SISTEMAS DE ANTENAS ANTIHURTO</h2>
      <p>
        Estos sistemas funciona con la instalación de antenas en las puertas de
        los negocios y etiquetas en los productos, si estas no son desactivadas
        de manera correcta en la caja registradora o no se quitan del producto,
        al pasar por la salida del establecimiento se activa una alarma que
        indica que artículos no han sido registrados, evitando así perdida de
        mercancía.
      </p>
      <img
        style={{ height: '40dvh' }}
        src={antenas}
        alt="antenas antirrobo para comercios"
      />
      <p>
        Suministramos e instalamos antenas y pines antirrobo para
        establecimientos comerciales, evitando la pérdida de tus productos y
        aumentando los ingresos de tu negocio; este servicio incluye: análisis
        del tipo de mercancía, instalación de pines adecuados e integración con
        sistemas de detección en puntos de salida, garantizando un control
        eficiente sin incomodar la experiencia del cliente.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Facilidad de gestión por parte de los empleados.</li>
        <li>Aumento de percepción de seguridad y control.</li>
        <li>Control ante posibles intrusos o situaciones sospechosas.</li>
        <li>Detención de robos y perdida de mercancía.</li>
        <li>Tranquilidad al contar con asesoría confiable y experta.</li>
      </ul>
    </div>
  );
};

export default Antirrobo;
